<script>
import firebase from "firebase/compat/app";

export default {
  data: () => ({
    declineBookingDialog: false,
    declinedSuccessDialog: false,
    otherReason: "",
    declinedReason: "",
  }),
  // mounted() {
  //   console.log('booking', this.booking);
  // },
  // computed: {
  //   size() {
  //     const size = { xs: 'x-small', sm: 'medium', lg: 'medium', xl: 'large' }[
  //       this.$vuetify.breakpoint.name
  //     ];
  //     return size ? { [size]: true } : {};
  //   },
  // },
  methods: {
    reload() {
      this.$store.dispatch("loadBookings");
      // vm.$forceUpdate();
      //go to dashboard using router
      //  this.$router.push({ name: 'dashboard' });
      //reload the page using vue router
      this.$router.go();
    },
    declineBooking() {
      console.log(this.booking.borrowerEmail);
      try {
        var bookingRef = firebase
          .firestore()
          .collection("bookings")
          .doc(this.booking.id);
        bookingRef.update({
          status: "declined",
          updatedAt: new Date(),
          declinedReason: this.declinedReason,
          declinedReasonOther: this.otherReason,
        });
        this.declineBookingDialog = false;
        this.declinedSuccessDialog = true;
      } catch (error) {
        const errorMessage = error.message;
        alert(errorMessage);
      }
      try {
        var addMessage = firebase
          .functions()
          .httpsCallable("bookingRequestDeclined");
        addMessage({
          id: this.booking.id,
          email: this.booking.borrowerEmail,
          borrowerName: this.booking.borrowerName,
          declinedReason: this.declinedReason,
          itemName: this.booking.itemName,
        });
      } catch (error) {
        const errorMessage = error.message;
        alert(errorMessage);
      } finally {
        (this.declineBookingDialog = false),
          (this.declinedSuccessDialog = true);
      }
    },
  },

  props: ["booking", "size"],
};
</script>

<template>
  <div>
    <v-hover v-slot="{ hover }">
      <v-btn
        v-bind="size"
        class="mx-1 mt-3 white--text font-weight-medium"
        :elevation="hover ? 16 : 4"
        :class="{ 'on-hover': hover }"
        color="accent"
        outlined
        style="border-radius: 10px"
        block
        @click="declineBookingDialog = true"
      >
        <v-icon class="mr-3">fas fa-times</v-icon>

        Decline
      </v-btn>
    </v-hover>
    <v-dialog
      v-model="declineBookingDialog"
      dialog-bottom-transition
      persistant
      rounded
      style="border-radius: 12px !important"
      :width="$vuetify.breakpoint.mdAndUp ? '50vw' : '90vw'"
    >
      <v-card style="border-radius: 12px !important">
        <v-card-title
          style="
            padding: 0px 24px !important;
            font-size: 1em !important;
            line-height: 1.43;
          "
          class="text-center black--text"
        >
          <v-icon small color="black" @click="declineBookingDialog = false"
            >mdi-close</v-icon
          >
          <p class="my-3 ml-auto mr-auto">
            Decline Booking
            <svg
              height="20px"
              width="20px"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path
                fill="#B22AF0"
                class="fa-primary"
                d="M175 320.1c9.373 9.371 24.56 9.379 33.94 0l47.03-47.03l47.03 47.03c9.373 9.371 24.56 9.379 33.94 0c9.375-9.375 9.375-24.56 0-33.94L289.9 240l47.03-47.03c9.375-9.375 9.375-24.56 0-33.94s-24.56-9.375-33.94 0l-47.03 47.03L208.1 159c-9.375-9.375-24.56-9.375-33.94 0s-9.375 24.56 0 33.94L222.1 240L175 287C165.7 296.4 165.7 311.6 175 320.1z"
              />
              <path
                fill="#F8955B"
                class="fa-secondary"
                d="M256 31.1c-141.4 0-255.1 93.13-255.1 208c0 49.63 21.35 94.98 56.97 130.7C44.5 421.1 2.729 465.1 2.229 466.5c-2.25 2.25-2.875 5.734-1.5 8.734C1.978 478.2 4.75 479.1 8 479.1c66.25 0 115.1-31.76 140.6-51.39c32.63 12.25 69.02 19.39 107.4 19.39c141.4 0 255.1-93.13 255.1-208S397.4 31.1 256 31.1zM336.1 287c9.375 9.375 9.375 24.56 0 33.94c-9.381 9.379-24.56 9.371-33.94 0l-47.03-47.03l-47.03 47.03c-9.381 9.379-24.56 9.371-33.94 0c-9.375-9.375-9.375-24.56 0-33.94L222.1 240L175 192.1c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0l47.03 47.03l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94L289.9 240L336.1 287z"
              />
            </svg>
          </p>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text>
          <p style="font-size: small" class="mb-5">
            <br />
            Please select a reason for declining this booking?
          </p>
          <v-radio-group v-model="declinedReason">
            <v-radio
              label="This item is currently being used"
              color="orange darken-3"
              value="This item is currently being used"
            ></v-radio>
            <v-radio
              label="It's booked during this period"
              color="orange darken-3"
              value="It is booked out during this period"
            ></v-radio>
          </v-radio-group>
          <v-text-field
            v-model="otherReason"
            style="border-radius: 12px"
            outlined
            persistent-hint
            name="name"
            placeholder="More Info..."
          >
          </v-text-field>
        </v-card-text>

        <div style="display: flex; justify-content: center">
          <v-btn
            elevation="8"
            :width="$vuetify.breakpoint.mdAndUp ? '7rem' : '5rem'"
            class="ebtn ma-3"
            @click="declineBookingDialog = false"
            >Close</v-btn
          >
          <v-btn
            elevation="8"
            :width="$vuetify.breakpoint.mdAndUp ? '7rem' : '5rem'"
            color="primary"
            class="ebtn ma-3"
            type="submit"
            @click="declineBooking(booking.id)"
            >Submit</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
      style="border-radius: 12px !important; overflow: hidden"
      v-model="declinedSuccessDialog"
      width="550"
    >
      <v-card
        style="border-radius: 12px !important; overflow: hidden"
        class="pa-3 text-center"
      >
        <v-card-title
          style="
            padding: 0px 24px !important;
            font-size: 1em !important;
            line-height: 1.43;
          "
          class="text-center black--text"
        >
          <v-icon small color="black" @click="declinedSuccessDialog = false"
            >mdi-close</v-icon
          >
          <p class="my-3 ml-auto mr-auto">Booking succesfully Declined</p>
        </v-card-title>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="12">
            <p>
              <br />
              <br />

              <span class="font-weight-bold text-subtitle-1"
                >We have notified the borrower of your selection</span
              >

              <!-- We really appreciate your feedback we will use it to improve our
              platform to better service you. We hope to get you amazing rental
              experiences in the future. -->
            </p>
          </v-col>
        </v-row>
        <div class="grid">
          <v-btn
            elevation="8"
            width="7rem"
            color="secondary"
            type="submit"
            value="Save Changes"
            class="ebtn"
            @click="reload()"
            >Continue</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<style lang="scss" scoped></style>
